<script setup>
import { Link, usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

// Components
import FooterCopyright from '@/Components/Footer/FooterCopyright.vue';
import FooterLinks from '@/Components/Footer/FooterLinks.vue';
import FooterContactdetails from './FooterContactdetails.vue';

// Images
import logo from '@/../img/logo.svg';

const companyDetails = computed(() => usePage().props.company_details);
const footerLinks = computed(() => usePage().props.menus.find((menu) => menu.name == 'footer'));
</script>

<template>
    <div class="relative overflow-hidden text-sm text-primary bg-secondary-medium md:text-base">
        <div class="container">
            <div class="py-8">
                <div class="md:flex md:gap-14">
                    <div class="md:w-4/12">
                        <Link :href="'/'" class="shrink-0 xl:block">
                            <img class="w-[222px] h-auto mb-6" :src="logo" alt="Logo" />
                        </Link>

                        <p>KvK: {{ companyDetails.kvk_number }}</p>
                        <p>BTW: {{ companyDetails.vat_number }}</p>
                    </div>

                    <div class="md:w-4/12">
                        <FooterContactdetails />
                    </div>

                    <div class="md:w-4/12">
                        <FooterLinks :links="footerLinks" />
                    </div>
                </div>
            </div>
        </div>

        <FooterCopyright />
    </div>
</template>
